// extracted by mini-css-extract-plugin
module.exports = {"SpinnerContainer":"Spinner_SpinnerContainer__1WnBD"};